var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRounds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 4.5,
    fill: "#007AFF",
    fillOpacity: 0.05,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 18C25.63 18 18 25.63 18 35C18 44.37 25.63 52 35 52C44.37 52 52 44.37 52 35C52 25.63 44.37 18 35 18ZM35 49.8C26.83 49.8 20.2 43.16 20.2 35C20.2 26.84 26.83 20.2 35 20.2C43.17 20.2 49.8 26.84 49.8 35C49.8 43.16 43.16 49.8 35 49.8Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.74 28.26C39.94 26.46 37.55 25.47 35 25.47C32.45 25.47 30.06 26.46 28.26 28.26C26.46 30.06 25.47 32.45 25.47 35C25.47 37.55 26.46 39.94 28.26 41.74C30.06 43.54 32.45 44.53 35 44.53C37.55 44.53 39.94 43.54 41.74 41.74C43.54 39.94 44.53 37.55 44.53 35C44.53 32.45 43.54 30.06 41.74 28.26ZM35 42.34C30.96 42.34 27.66 39.05 27.66 35C27.66 30.95 30.96 27.66 35 27.66C39.04 27.66 42.34 30.96 42.34 35C42.34 39.04 39.05 42.34 35 42.34Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRounds);
export default __webpack_public_path__ + "static/media/Rounds.b033559eb08c49d972854b27e3d06323.svg";
export { ForwardRef as ReactComponent };